export default function () {
  return {
    errors: {},
    category: {
      id: null,
      slug: '',
      name: '',
      description: '',
    },
  }
}
